import { object, ObjectSchema, string } from 'yup';

import { OpenDateInterval } from '@client/api';

import { transformDateToIsoDateString } from '../yup-customizations';

const schema: ObjectSchema<OpenDateInterval> = object({
  start: string().nullable().transform(transformDateToIsoDateString),
  end: string().nullable().transform(transformDateToIsoDateString)
});

export { schema as openDateIntervalSchema };
